<div #accordionContent class="content" [style.height]="contentHeight">
  <ng-content select="[content]"></ng-content>
</div>
<div (click)="toggle()" class="title display-utils-row">
  <ng-content select="[title]"></ng-content>
</div>